// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

// --- RxJs
import { Observable } from 'rxjs';

// --- HS Code
import { environment } from '../../../environments/environment';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class StandardHeadersService implements HttpInterceptor {
  constructor() { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    req = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Client-Id': environment.authSettings.client_id,
        'X-Version': environment.apiVersion,
      }
    });

    return next.handle(req);
  }
}
